module.exports = __webpack_public_path__ + "assets/media/day16.ed11d2d5.mp3";